module.exports = __webpack_public_path__ + "img/mastercard.39748d61.svg";